import { css } from 'aphrodite';
import * as React from 'react';
import { useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../../web/components-v2/Select';
import { styleSheet } from '../styles';

export interface IVerticalSelectOption {
	dataContext: string;
	id: string;
	text: string;
}

interface IProps {
	disabled?: boolean;
	onChange?: (item: IVerticalSelectOption) => void;
	options: IVerticalSelectOption[];
	selected?: string;
}

export const VerticalSelect: React.FC<IProps> = ({ disabled, onChange, options, selected }) => {
	const [selectedOption, selectOption] = useState<string>(selected || '');

	const onValueChange = (value: string) => {
		const option = options.find(x => x.dataContext === value);
		if (option) {
			onChange?.(option);
			selectOption(option.dataContext);
		}
	};

	return (
		<div className={css(styleSheet.selectWrapper)}>
			<Select value={selectedOption} onValueChange={onValueChange} disabled={disabled}>
				<SelectTrigger styles={styleSheet.selectTrigger} aria-label='Filter by lead pool'>
					<SelectValue placeholder='Select an option'>
						{(value: string) => options.find(x => x.dataContext === value)?.text}
					</SelectValue>
				</SelectTrigger>
				<SelectContent>
					{options.map(option => (
						<SelectItem key={option.id} value={option.dataContext}>
							{option.text}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	);
};
